module.exports = __webpack_public_path__ + "img/home-saude.b70f70f2.svg";